import { api } from 'services/api';

import { COMMON_DATE_FORMAT } from 'constants/common';
import dayjs from 'dayjs';
import { camelCase, flow, get, map, mapKeys } from 'lodash/fp';
import { createRestProvider } from './restProvider';

export const locationsFYIDataProvider = createRestProvider();

locationsFYIDataProvider.getList = async ({ metaData, pagination }) => {
  const response = await api.get<{
    count: number;
    data: Record<string, unknown>[];
  }>('/admin/get-fyi-messages-by-location-id', {
    params: {
      locationId: metaData?.locationId,
      limit: pagination?.pageSize,
      offset: (get('current')(pagination) - 1) * get('pageSize')(pagination),
      isActive: true
    }
  });

  const normalizedData = flow(map(mapKeys(camelCase)))(response.data);

  return {
    data: normalizedData,
    total: response.count
  };
};

locationsFYIDataProvider.create = async ({
  metaData,
  variables: inputVariables
}) => {
  const cloneVariable: any = inputVariables;

  const response = await api.post<any>('/admin/create-fyi-message', {
    ...inputVariables,
    dateFrom: cloneVariable?.dateFrom
      ? dayjs(cloneVariable?.dateFrom).format(COMMON_DATE_FORMAT)
      : null,
    dateTo: cloneVariable?.dateTo
      ? dayjs(cloneVariable?.dateTo).format(COMMON_DATE_FORMAT)
      : null,
    locationId: metaData?.locationId
  });

  return {
    data: response
  };
};

locationsFYIDataProvider.deleteOne = async ({ id }) => {
  const response = await api.post<any>('/admin/deactive-fyi-message', {
    id: Number(id)
  });

  return {
    data: response
  };
};

locationsFYIDataProvider.update = async ({
  metaData,
  variables: inputVariables
}) => {
  const cloneVariable: any = inputVariables;

  const response = await api.post<any>('/admin/update-fyi-message', {
    ...inputVariables,
    dateFrom: cloneVariable?.dateFrom
      ? dayjs(cloneVariable?.dateFrom).format(COMMON_DATE_FORMAT)
      : null,
    dateTo: cloneVariable?.dateTo
      ? dayjs(cloneVariable?.dateTo).format(COMMON_DATE_FORMAT)
      : null,
    id: metaData?.id
  });

  return {
    data: response
  };
};
